import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

import { getAccount } from '../actions/account';
import { getContestById, getContests, submitEntry, likeContestEntry, removeEntryLike, deleteEntry } from '../actions/contests';
import ContestDetail from '../components/contest-detail';

function mapStateToProps(state) { // eslint-disable-line require-jsdoc
    const { currentUser, contests, account } = state;
    return {
        contests,
        currentUser,
        account,
    };
}

function mapDispatchToProps(dispatch) { // eslint-disable-line require-jsdoc
    const actions = {
        getContestById,
        getContests,
        getAccount,
        submitEntry,
        likeContestEntry,
        removeEntryLike,
        deleteEntry,
    };

    return bindActionCreators(actions, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ContestDetail));



// WEBPACK FOOTER //
// ./src/containers/contest-detail.js